import TYPES from './data/product-types';

const calculateProductMonthly = (product) => {
    const monthly = parseFloat(product.price) / 48;
    if (isNaN(monthly)) {
        console.warn('The monthly product price was set incorrectly.');
        return 'Error';
    } else {
        return monthly;
    }
};

/**
 *
 * Loose type defs for mapping function..
 * Product is based on commonamlities between products found in data/products/*
 *
 * @typedef { import('./data/products')[0] } Product
 * @typedef { any } VariantNode
 */

export const BASE_PRICE = 3999;
export const MONTHLY_TERM = 48;

/**
 *
 * Map function to combine both local stored product data with incoming
 * Shopify variant data.
 *
 * Each item will be stored within the ShopifyService.products
 *
 * @param { Product } product
 * @param { VariantNode } variantNode
 */
export const mapShopifyItem = (product, variantNode) => {
    // console.log('VARIANT NODE :', variantNode);

    const variantId = variantNode.id;
    const price = parseFloat(variantNode.priceV2.amount);

    // XS1 base price

    let additional = {};
    switch (product.type) {
        case TYPES.XS1:
            const accessoryPrice = price - BASE_PRICE;
            const basePriceMonthly = Math.floor(BASE_PRICE / MONTHLY_TERM);
            const accessoryPriceMonthly = Math.floor(accessoryPrice / MONTHLY_TERM);

            additional = {
                basePrice: BASE_PRICE,
                accessoryPrice,
                basePriceMonthly,
                accessoryPriceMonthly,
            };

            break;

        case TYPES.XS1_SUBSCRIPTION:
            let compareAtPrice = price;
            if (variantNode.compareAtPriceV2) {
                compareAtPrice = parseFloat(variantNode.compareAtPriceV2.amount);
            }

            const discountFloat = 1 - price / compareAtPrice;
            const discount = Math.round(100 * discountFloat) + '%';
            const hasDiscount = discountFloat !== 0;

            const discountedMonthlyPrice = (price / (product.term * 12)).toFixed(2);
            const monthlyPrice = (compareAtPrice / (product.term * 12)).toFixed(2);

            additional = {
                compareAtPrice,
                discount,
                discountFloat,
                monthlyPrice,
                discountedMonthlyPrice,
                hasDiscount,
            };
            break;
    }

    return {
        ...product,
        ...additional,
        variantId,
        price,
    };
};
